// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contents .intro-yy {
    /* display: flex; */
    flex-wrap: wrap;
    /* width:calc(100% + 1rem);  */
    /* height:100%; */
    /* margin-left: -.5rem; */
    background: #fff;
    padding: 20px 0px;
    box-shadow: none;
}

/* payForm */
.content-wrap .payForm {
    display: none;
    margin: 0;
    padding: 0;
}

.content-wrap .payForm.active {
    display: block;
}

.payForm .form-label {
    margin-bottom: .375rem;
    font-size: .8125rem;
    font-weight: bold;
}

.payForm .input {
    width: 100%;
    /* margin: 0 .5rem 1rem; */
    margin: 0 0 0.75rem;
}

.payForm .input.w33 {
    width: calc(33.33% - 1rem);
}

.payForm .input.w50 {
    width: calc(50% - 1rem);
}

.payForm .input.w66 {
    width: calc(66.66% - 1rem);
}

.payForm .input .multiple {
    display: flex;
    align-items: center;
}

.payForm .input .multiple span {
    padding: 0 .375rem;
}

.payForm .mt-2,
.payForm .mt-3 {
    margin: 0;
}

.payForm .pos_aps_r {
    margin: .25rem 0 -1.25rem;
}

.payForm .payBt {
    width: 100%;
    margin: 1rem 0;
    text-align: center;
}

.payForm .payBt .btn {
    width: 60%;
    max-width: 12.5rem;
}

.payment {
    height: 100%;
}

.payment .inner-wrap h2.title {
    padding-bottom: 1rem;
    /* margin: 0 0.5rem 0; */
    font-size: 1.0625rem;
    font-weight: bold;
    line-height: 3.25rem;
}

.payment .inner-wrap>ul.title li:nth-child(1) {
    width: 33rem;
}

.payment .inner-wrap>ul.title li:nth-child(2) {
    width: calc(100% - 33rem);
}

.payment .cardInfo .tabulator-footer .tabulator-page.active {
    background: #1a120b;
    color: #fff;
}

.payment .cardInfo .tabulator-footer .tabulator-page.active:hover {
    color: #fff;
    background: #3D3C42;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/css/payment.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,wBAAwB;IACxB,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB","sourcesContent":[".contents .intro-yy {\r\n    /* display: flex; */\r\n    flex-wrap: wrap;\r\n    /* width:calc(100% + 1rem);  */\r\n    /* height:100%; */\r\n    /* margin-left: -.5rem; */\r\n    background: #fff;\r\n    padding: 20px 0px;\r\n    box-shadow: none;\r\n}\r\n\r\n/* payForm */\r\n.content-wrap .payForm {\r\n    display: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.content-wrap .payForm.active {\r\n    display: block;\r\n}\r\n\r\n.payForm .form-label {\r\n    margin-bottom: .375rem;\r\n    font-size: .8125rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.payForm .input {\r\n    width: 100%;\r\n    /* margin: 0 .5rem 1rem; */\r\n    margin: 0 0 0.75rem;\r\n}\r\n\r\n.payForm .input.w33 {\r\n    width: calc(33.33% - 1rem);\r\n}\r\n\r\n.payForm .input.w50 {\r\n    width: calc(50% - 1rem);\r\n}\r\n\r\n.payForm .input.w66 {\r\n    width: calc(66.66% - 1rem);\r\n}\r\n\r\n.payForm .input .multiple {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.payForm .input .multiple span {\r\n    padding: 0 .375rem;\r\n}\r\n\r\n.payForm .mt-2,\r\n.payForm .mt-3 {\r\n    margin: 0;\r\n}\r\n\r\n.payForm .pos_aps_r {\r\n    margin: .25rem 0 -1.25rem;\r\n}\r\n\r\n.payForm .payBt {\r\n    width: 100%;\r\n    margin: 1rem 0;\r\n    text-align: center;\r\n}\r\n\r\n.payForm .payBt .btn {\r\n    width: 60%;\r\n    max-width: 12.5rem;\r\n}\r\n\r\n.payment {\r\n    height: 100%;\r\n}\r\n\r\n.payment .inner-wrap h2.title {\r\n    padding-bottom: 1rem;\r\n    /* margin: 0 0.5rem 0; */\r\n    font-size: 1.0625rem;\r\n    font-weight: bold;\r\n    line-height: 3.25rem;\r\n}\r\n\r\n.payment .inner-wrap>ul.title li:nth-child(1) {\r\n    width: 33rem;\r\n}\r\n\r\n.payment .inner-wrap>ul.title li:nth-child(2) {\r\n    width: calc(100% - 33rem);\r\n}\r\n\r\n.payment .cardInfo .tabulator-footer .tabulator-page.active {\r\n    background: #1a120b;\r\n    color: #fff;\r\n}\r\n\r\n.payment .cardInfo .tabulator-footer .tabulator-page.active:hover {\r\n    color: #fff;\r\n    background: #3D3C42;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
